import React, { useRef, useEffect, useState } from "react";
import { BackNextButton } from "../../../../../common";
import { useUpdateCompanyMutation, useUpdateCompanyDraftMutation, useUpdateCompanyRequestStatusMutation, useUpdateCompanyDraftEditMutation, useGetCompanyRequestStatusMutation, useFetchCompanyDraftEditMutation } from "../../../../../../store/Company/companyApiSlice";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import { useGetCompanyQuery } from "../../../../../../store/Company/companyApiSlice";
import useCompanyUpdate from "../useCompanyFollowUpdate"

import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";
export const Social = ({ onPrev, onNext, onSkip }) => {
  const twitterRef = useRef();
  const facebookRef = useRef();
  const linkedinRef = useRef();
  const instagramRef = useRef();
  const websiteRef = useRef();
  const dispatch = useDispatch();

  const { currentEditingCompany } = useSelector((state) => state.company);
  const [currentEditingCompanyDraft, setcurrentEditingCompanyDraft] = useState(null);

  const [updateCompany, { isLoading }] = useUpdateCompanyMutation();
  const [UpdateCompanyDraft, { isLoadingDraft }] = useUpdateCompanyDraftMutation();
  const [UpdateCompanyDraftEdit, { isLoadingDraftEdit }] = useUpdateCompanyDraftEditMutation();
  const [FetchCompanyDraftEdit, { isLoadingFetchDraft }] = useFetchCompanyDraftEditMutation();
  const { token } = useSelector((state) => state.auth);

  const [companyVerificationStatus, setcompanyVerificationStatus] = useState("pending");
  const [requestID, setrequestID] = useState(null);
  const [verifiedCompany, setverifiedCompany] = useState(false);
  const [getCompanyRequestStatus] = useGetCompanyRequestStatusMutation();
  const [updateCompanyRequestStatus] = useUpdateCompanyRequestStatusMutation();
  const currentCompId = currentEditingCompany?.companyID;
  const { data, refetch } = useGetCompanyQuery({
    token,
    companyId: currentCompId,
  })

  const handleUpdateCompany = useCompanyUpdate();

  const facebook_URL = data?.facebook;
  const twitter_URL = data?.twitter;
  const linkedin_URL = data?.linkedin;
  const instagram_URL = data?.instagram;
  const website_URL = data?.website;


  function addHttpsToFilled(url) {
    if (!url || url.trim() === "") {
      return null;
    }

    if (!/^https?:\/\//i.test(url.trim())) {
      return 'https://' + url.trim();
    }

    return url.trim();
  }

  useEffect(() => {
    if (currentEditingCompany?.userCompany) {
      let userindividualID = localStorage.getItem('userindividualID');

      const companyStatus = async () => {
        let dataval = await getCompanyRequestStatus({
          companyID: currentEditingCompany.companyID,
          individualID: userindividualID || currentEditingCompany?.userCompany[0]?.individualID?.individualID,
          token,
        });
        if (dataval) {
          let statusValue = dataval.data?.filter(item => item?.companyID?.companyID == currentEditingCompany.companyID)
          if (statusValue?.length > 0) {
            let companyStatus = statusValue[statusValue.length - 1];
            setcompanyVerificationStatus(companyStatus?.status);
            setrequestID(companyStatus?.requestID);
          }
        }
      }
      companyStatus()
    }
    if (currentEditingCompany && currentEditingCompany?.verifiedCompany) {
      setverifiedCompany(true)

    }
    if (currentEditingCompany && companyVerificationStatus == 'Modified') {
      fetchDraftDetails();

    } else if (data) {
      twitterRef.current.value = addHttpsToFilled(twitter_URL) || "";
      facebookRef.current.value = addHttpsToFilled(facebook_URL) || "";
      linkedinRef.current.value = addHttpsToFilled(linkedin_URL) || "";
      instagramRef.current.value = addHttpsToFilled(instagram_URL) || "";
      websiteRef.current.value = addHttpsToFilled(website_URL) || "";
    }
  }, [currentEditingCompany, companyVerificationStatus, data]);

  const fetchDraftDetails = async () => {
    try {
      const fetchDraft = await FetchCompanyDraftEdit({
        companyId: currentEditingCompany.companyID,
        token
      }).unwrap();
      if (fetchDraft?.data) {
        setcurrentEditingCompanyDraft(fetchDraft?.data[0]);
        twitterRef.current.value = addHttpsToFilled(fetchDraft?.data[0]?.twitter) || addHttpsToFilled(twitter_URL) || "";
        facebookRef.current.value = addHttpsToFilled(fetchDraft?.data[0]?.facebook) || addHttpsToFilled(facebook_URL) || "";
        linkedinRef.current.value = addHttpsToFilled(fetchDraft?.data[0]?.linkedin) || addHttpsToFilled(linkedin_URL) || "";
        instagramRef.current.value = addHttpsToFilled(fetchDraft?.data[0]?.instagram) || addHttpsToFilled(instagram_URL) || "";
        websiteRef.current.value = addHttpsToFilled(fetchDraft?.data[0]?.website) || addHttpsToFilled(website_URL) || "";
      }
    } catch (error) {
    }
  }
  const handleSubmitDraft = async () => {
    try {
      const updatecompanyStatus = await updateCompanyRequestStatus({
        requestID: requestID,
        token
      }).unwrap();
      const res = await UpdateCompanyDraft({
        data: {
          companyID: currentEditingCompany.companyID,
          twitter: `${twitterRef.current.value}`,
          facebook: `${facebookRef.current.value}`,
          instagram: `${instagramRef.current.value}`,
          linkedin: `${linkedinRef.current.value}`,
          website: `${websiteRef.current.value}`,
          social_media_status: "Modified"
        },
        token
      }).unwrap();
      if (res) {
        onNext(4, "Logo & Banner", "About");
      }

    } catch (error) {
    }
  }
  const handleSubmitDraftEdit = async () => {
    try {
      const res = await UpdateCompanyDraftEdit({
        data: {
          twitter: `${twitterRef.current.value}`,
          facebook: `${facebookRef.current.value}`,
          instagram: `${instagramRef.current.value}`,
          linkedin: `${linkedinRef.current.value}`,
          website: `${websiteRef.current.value}`,
          social_media_status: "Modified"
        },
        companyId: currentEditingCompany.companyID,
        token,
        type: "socialmedia"
      }).unwrap();
      if (res) {
        onNext(4, "Logo & Banner", "About");
      }
    } catch (error) {
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (currentEditingCompanyDraft == null && (companyVerificationStatus == 'Completed' || companyVerificationStatus == 'Modified')) {
      handleSubmitDraft()
    } else if (companyVerificationStatus == 'Modified') {
      handleSubmitDraftEdit()
    } else {
      try {
        const res = await updateCompany({
          data: {
            twitter: `${twitterRef.current.value}`,
            facebook: `${facebookRef.current.value}`,
            instagram: `${instagramRef.current.value}`,
            linkedin: `${linkedinRef.current.value}`,
            website: `${websiteRef.current.value}`,
            social_media_status: currentEditingCompany.social_media_status == 'Requested' ? "Requested" : "Modified"
          },
          token,
          companyId: currentEditingCompany.companyID,
        }).unwrap();

        if (res) {

          dispatch(setCurrentEditingCompany(res));
          const result = await handleUpdateCompany(currentEditingCompany.companyID, "Social Media Updated", token);
          if (!result.success) {
            console.error(result.error);
          }
          onNext(4, "Logo & Banner", "About");
          refetch();

        }
      } catch (error) {

      }
    }
  };

  return (
    <div className="mt-5 mr-20 ">
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
        Social Media <span className="pendingapproval">
          {
            ((currentEditingCompanyDraft && currentEditingCompanyDraft?.social_media_status == 'raised' || currentEditingCompanyDraft?.social_media_status == 'Modified')) ? <Requested /> :
              currentEditingCompany?.social_media_status === "Verified" ? <Verified /> : currentEditingCompany?.social_media_status === "Declined" ?
                <Declined /> : currentEditingCompany?.social_media_status === "Skipped" ? <Skipped /> : currentEditingCompany?.social_media_status === "Requested" && <Requested />
          }
        </span>
      </h3>
      <div className="border border-slate rounded-lg p-8 mb-6">
        <div className="flex gap-4 w-full mb-6">
          <CustomInput label="X (previously Twitter)" value={twitterRef} verifiedCompany={verifiedCompany && twitterRef.current.value != ''} />
          <CustomInput label="Facebook" value={facebookRef} verifiedCompany={verifiedCompany && facebookRef.current.value != ''} />
        </div>
        <div className="flex gap-4 w-full mb-6">
          <CustomInput label="LinkedIn" value={linkedinRef} verifiedCompany={verifiedCompany && linkedinRef.current.value != ''} />
          <CustomInput label="Instagram" value={instagramRef} verifiedCompany={verifiedCompany && instagramRef.current.value != ''} />
        </div>
        <div className="flex gap-4 w-full mb-6">
          <CustomInput label="Website" value={websiteRef} verifiedCompany={verifiedCompany && websiteRef.current.value != ''} />
        </div>
        <BackNextButton
          onPrev={() => onPrev(2, "Address & Contact Information", "About")}
          onNext={handleSubmit}
          onSkip={() => onSkip(4, "Logo & Banner", "About")}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export const CustomInput = ({ label, value, verifiedCompany }) => {
  return (
    <div className="w-full">
      <label className="block mb-1 text-primary text-f14 font-semibold text-left">
        {label}
      </label>
      <div className="flex">
        <input
          type="text"
          ref={value}
          className="w-full focus:border-primary px-3 py-2 border border-input rounded-r rounded-rb bg-input text-gray-900 text-sm block p-2.5"
        />
      </div>
    </div>
  );
};
